export interface CreateBundleUsageRequest {
  total_session_quantity: number;
  utilized_session_quantity: number;
  user_id: string;
  status: BundleUsageStatus;
  bundle_id: string;
  source_usage_id?: string | null;
  start_date: string; // ISO date
  end_date: string;   // ISO date
}

export enum BundleUsageStatus {
  ACTIVE = "ACTIVE",
  COMPLETED = "COMPLETED",
  COMPLETED_WITH_PARTIAL_REFUND = "COMPLETED_WITH_PARTIAL_REFUND",
  EXPIRED = "EXPIRED",
  FULLY_REFUNDED = "FULLY_REFUNDED",
  INACTIVE = "INACTIVE",
  TRANSFERRED = "TRANSFERRED",
  CONVERTED = "CONVERTED",
}

// The enum's values as a plain string union. API payloads carry the bare
// string, so response types (BundleUsage.status) use this instead of the enum:
// literal comparisons like `status === "ACTIVE"` keep type-checking, while any
// value outside the server's BundleUsageStatus is a compile error.
export type BundleUsageStatusValue = `${BundleUsageStatus}`;

export const bundleUsageStatus: Record<string, BundleUsageStatus> = {
  ACTIVE: BundleUsageStatus.ACTIVE,
  COMPLETED: BundleUsageStatus.COMPLETED,
  COMPLETED_WITH_PARTIAL_REFUND: BundleUsageStatus.COMPLETED_WITH_PARTIAL_REFUND,
  EXPIRED: BundleUsageStatus.EXPIRED,
  FULLY_REFUNDED: BundleUsageStatus.FULLY_REFUNDED,
  INACTIVE: BundleUsageStatus.INACTIVE,
  TRANSFERRED: BundleUsageStatus.TRANSFERRED,
  CONVERTED: BundleUsageStatus.CONVERTED,
};